const modalGallery = document.getElementById('zoomed-gallery-modal');
const galleryItems = document.getElementsByClassName('zoomed-gallery__item');

document.getElementById('zoomed-gallery').addEventListener('click', (event) => {
  if (event.target.parentElement.classList.contains('zoomed-gallery__item')) {
    modalGallery.classList.toggle('modal-opened');

    const zoomed_thumb_slider_swiper = new Swiper('.zoomed-modal-thumb', {
      direction: 'horizontal',
      slidesPerView: 2,
      spaceBetween: 40,
      centeredSlides: true,
      navigation: {
        nextEl: '.zoomed-modal-thumb-next',
        prevEl: '.zoomed-modal-thumb-prev',
      },
    });

    const zoomed_gallery_swiper = new Swiper('.zoomed-gallery-swiper', {
      direction: 'horizontal',
      loop: false,
      slidesPerView: 'auto',
      spaceBetween: 30,
      centeredSlides: true,
      navigation: {
        nextEl: '.zoomed-gallery-swiper-button-next',
        prevEl: '.zoomed-gallery-swiper-button-prev',
      },
      thumbs: {
        swiper: zoomed_thumb_slider_swiper,
      },
      zoom: {
        maxRatio: 5,
      },
    });

    const zoomFactor = 1.2;
    const magnifierSize = 300;

    zoomed_gallery_swiper.slides.forEach((slide) => {
      const image = slide.querySelector('.gallery-zoomable');
      const magnifier = slide.querySelector('.gallery-magnifier');

      if (!magnifier) {
        console.error('Canvas not found for slide:', slide);
        return;
      }

      const ctx = magnifier.getContext('2d');

      magnifier.width = magnifierSize;
      magnifier.height = magnifierSize;

      const img = new Image();
      img.src = image.src;

      const isMobile = window.innerWidth <= 768;

      if (isMobile) {
        return;
      } else {
        image.addEventListener('mousemove', (e) => {
          const rect = image.getBoundingClientRect();

          const scaleX = img.width / rect.width;
          const scaleY = img.height / rect.height;

          const x = (e.clientX - rect.left) * scaleX;
          const y = (e.clientY - rect.top) * scaleY;

          const offset = 20;
          magnifier.style.left = `${e.clientX + offset}px`;
          magnifier.style.top = `${e.clientY - magnifierSize - offset}px`;
          magnifier.style.display = 'block';

          ctx.clearRect(0, 0, magnifierSize, magnifierSize);
          ctx.drawImage(
            img,
            x - magnifierSize / (2 * zoomFactor),
            y - magnifierSize / (2 * zoomFactor),
            magnifierSize / zoomFactor,
            magnifierSize / zoomFactor,
            0,
            0,
            magnifierSize,
            magnifierSize,
          );
        });

        image.addEventListener('mouseleave', () => {
          magnifier.style.display = 'none';
        });
      }
    });
  }
});

document.getElementById('zoomed-gallery__close').addEventListener('click', (event) => {
  modalGallery.classList.toggle('modal-opened');
});
